import type { FileRejection } from "@mantine/dropzone";

// Doit rester alignee sur MAX_FILE_SIZE cote serveur (5.megabytes dans
// Admin::ArticleImagesController et Vehicles::PhotoImportInteractor). Le
// filtrage client n'est qu'ergonomique — contournable au curl — donc le
// serveur reste seul juge ; les deux valeurs doivent bouger ensemble.
export const MAX_UPLOAD_SIZE = 5 * 1024 ** 2;

// Libelles repris mot pour mot des reponses serveur : un rejet cote client
// et un rejet cote serveur doivent se lire de la meme facon.
export const TOO_LARGE_MESSAGE = "Image trop volumineuse (max 5 Mo).";
export const INVALID_TYPE_MESSAGE = "Format d'image non supporté.";

// Codes remontes par react-dropzone, via le onReject de Mantine.
export const rejectionMessage = (rejections: FileRejection[]): string => {
  const codes = rejections.flatMap((rejection) =>
    rejection.errors.map((error) => error.code),
  );

  if (codes.includes("file-too-large")) return TOO_LARGE_MESSAGE;
  if (codes.includes("file-invalid-type")) return INVALID_TYPE_MESSAGE;

  return "Ce fichier n'a pas pu être accepté.";
};
